<template>
    <div class="g-time">
        <div class="hour">
            <div class="list">
                <div class="list-item" v-for="(item,i) in hourList" :key="i">{{item}}</div>
            </div>
        </div>
        <div class="minutes">
            <div class="list">
                <div class="list-item" v-for="(item,i) in hourList" :key="i">{{item}}</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'GTime',
    data(){
        return {
            hourList: [],
            minutesList: []
        }
    },
    props: ['time'],
    created(){
        var maxHour = parseInt(this.time/60);
        var maxMinutes = this.time%60;
        for(var i=0; i<maxHour+1; i++){
            this.hourList.push(i);
        }
        for(var i=0; i<maxMinutes; i++){
            this.minutesList.push(i)
        }
    },
    methods:{

    }
}
</script>


// WEBPACK FOOTER //
// src/components/timer.vue